import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import OrganizationVerificationPopup from './OrganizationVerificationPopup';
import LenderOnboardingForm from './LenderOnboardingForm';

const LenderOnboardingPopup = ({ open, onClose, onBack, initialData }) => {
  
  const [showVerification, setShowVerification] = useState(false);
  const [verificationData, setVerificationData] = useState({
    lenderId: null,
    userId: null,
    formData: null
  });

  const handleVerificationStart = (lenderId, formData, userId) => {
    setVerificationData({ lenderId, userId, formData });
    setShowVerification(true);
  };

  const handleVerificationClose = () => {
    setShowVerification(false);
    setVerificationData({ lenderId: null, userId: null, formData: null });
    
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 100);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  const handleBack = () => {
    if (onBack) {
      onBack();
    }
  };

  return (
    <>
      <Dialog 
        open={open && !showVerification} 
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <Box sx={{ position: 'relative' }}>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <DialogContent>
            <LenderOnboardingForm 
              initialData={initialData}
              onVerificationStart={handleVerificationStart}
              onBack={handleBack}
            />
          </DialogContent>
        </Box>
      </Dialog>

      <OrganizationVerificationPopup
        open={showVerification}
        onClose={handleVerificationClose}
        formData={verificationData.formData}
        initialData={initialData}
        lenderId={verificationData.lenderId}
        userId={verificationData.userId}
        preventClose={true}
      />
    </>
  );
};

export default LenderOnboardingPopup; 